/** The Cottage Trio mark and the product name, as on every FellowFlats surface. */
export function Brand() {
  return (
    <div className="flex items-center gap-2">
      <img src="/icon.svg" alt="" className="h-7 w-7" />
      <span className="text-lg font-bold tracking-tight">
        FellowFlats <span className="font-medium text-muted-foreground">Admin</span>
      </span>
    </div>
  );
}
